import type { FooterLinks } from '../../pages/api/types';
import Icon from '../generic/Icon';
import { CookieConsentModal } from '../generic/Modals';
import type { Keyed, KeyedArray } from '../sanity/types';
import preventDefault from '../utils/preventDefault';
import { trackFooterLinkClick } from '../utils/trackLinkClick';
import * as style from './FooterLinks.module.css';

export default function FooterLinks({ footerLinks }: { footerLinks: KeyedArray<FooterLinks> | undefined }) {
    return (
        <div className={style.footerLinks} onClick={trackFooterLinkClick}>
            <div className="section__inner-container">
                <div className={style.groups}>
                    {footerLinks?.map((p) => (
                        <FooterGroup key={p._key} {...p} />
                    ))}
                </div>
            </div>
        </div>
    );
}

function FooterGroup({ _key, title, links, link }: Keyed<FooterLinks>) {
    return (
        <div className={style.group}>
            <h2 className={style.title}>
                <a href={link?.internalReference?.path}>{title}</a>
            </h2>
            <menu id={_key} className={style.links}>
                {links.map((p) => {
                    switch (p._type) {
                        case 'cookie-administration':
                            return (
                                <li key={p._key}>
                                    <a href="#" onClick={preventDefault(() => CookieConsentModal.call())}>
                                        {p.title}
                                    </a>
                                </li>
                            );
                        case 'namedInternalLink':
                            return (
                                <li key={p._key}>
                                    <a href={p.link?.internalReference?.path}>{p.name || p.link?.internalReference?.title}</a>
                                </li>
                            );
                        case 'namedExternalLink':
                            return (
                                <li key={p._key}>
                                    <a
                                        href={p.link?.href}
                                        target={p.link?.blank ? '_blank' : undefined}
                                        rel={p.link?.blank ? 'noreferrer' : undefined}
                                    >
                                        <span>{p.name}</span>&nbsp;
                                        <Icon className="icon-external-link" renderWithSpan />
                                    </a>
                                </li>
                            );
                        case 'namedRelativeLink':
                            return (
                                <li key={p._key}>
                                    <a href={p.url}>{p.name}</a>
                                </li>
                            );
                    }
                })}
            </menu>
        </div>
    );
}
